export class ReprocessFilterDto {
    dateName: string = '';
    date: string = '';
    status: Array<string> = [];
    woList: string = '';
}
  